// extracted by mini-css-extract-plugin
module.exports = {"icon":"styles_icon__hqp8m","label":"styles_label__EUpVX","skeleton-animation":"styles_skeleton-animation__1qOcT"};